// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCQiHQvzBqqQEaXyIkFpqzkm1oAyzZ8liY",
  authDomain: "psa-toronto.firebaseapp.com",
  projectId: "psa-toronto",
  storageBucket: "psa-toronto.firebasestorage.app",
  messagingSenderId: "937289529629",
  appId: "1:937289529629:web:1c22f05609139047ac49f4"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
